// DEPENDENCIES
import React, { useEffect, useState, useRef } from 'react';
import '../../../../../assets/custom/mobile-forms.css';
import { connect } from 'react-redux';
import moment from 'moment';
import { useFormik } from "formik";
// COMPONENTS
import DataTable from 'react-data-table-component';
import Select from 'react-select';
import { Link, useParams } from 'react-router-dom';
// ICONS
// CUSTOM COMPONENTS
import { Modal } from 'react-bootstrap';
import Section from '../../../../components/Section';
import ContentBlock from '../../../../components/ContentBlock';
import CustomBlock from '../../../../components/CustomBlock';
import ContentHeader from '../../../../components/ContentHeader';
import InputBlock from '../../../../components/InputBlock';
import SelectBlock from '../../../../components/SelectBlock';
import Button from '../../../../components/Button';
// PARTIALS
// SERVICES AND HELPERS
import PCMDataSheetValidator from '../../../../../helpers/validators/PCMDataSheetValidator';
import PCMDataSheetLineItemValidator from '../../../../../helpers/validators/PCMDataSheetLineItemValidator';
import * as pcmDataSheetService from '../../../../../services/form/pcmDataSheetService';
import * as alert from '../../../../../redux/alertSnackBarRedux';
import * as confirmModal from '../../../../../redux/confirmModalRedux';
import * as jobFormService from '../../../../../services/service/jobFormService';
import * as helper from '../../../../../helpers/helper';
import * as weatherService from '../../../../../services/weatherService';
import * as pcmChainOfCustodyService from '../../../../../services/form/pcmChainOfCustodyService';

const initialState = {
    id: 0,
    projectLocationId: null,
    area: '',
    operation: '',
    sampleMedia: '',
    analyzedBy: '',
    analyticalMethod: '',
    collectedBy : '',
    calibrationMethod: '',
    calibrationNumber: '',
    lotNumber: '',
    windDirection: '',
    maxWindSpeed: '',
    minWindSpeed: '',
    humidity: '',
    temperature: '',
    pcmDataSheetLineItems: []
}

const lineItemInitialState = {
    id: 0,
    sampleNumber: '',
    pumpNumber: '',
    sampleType: '',
    exposureTimeOn: null,
    exposureTimeOff: null,
    nonExposureTime: '',
    preCalibrationNumber: '',
    postCalibrationNumber: '',
    fibers: '',
    fields: '',
    sampleInformation: '',
    workerId: '',
    ppe: '',
    elapsedTime: '',
    flowRate: '',
    fcc: '',
    twa: '',
    dateTime: ''
}

const PCMDataSheetForm = (props) => {
    const iframeRef = useRef();
    const { jobFormId, edit } = useParams();
    const { showAlert, showConfirmModal, hideConfirmModal, setProcessing, history, auth } = props;
    const [loading, setLoading] = useState(false);
    const [pcmDataSheet, setPCMDataSheet] = useState(initialState);
    const [locationOptions, setLocationOptions] = useState([]);
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [isFetchingWeather, setIsFetchingWeather] = useState(false);
    const [lineItemModel, setLineItemModel] = useState(lineItemInitialState);
    const [showExtra, setShowExtra] = useState(false);
    const [switchMode, setSwitchMode] = useState(false);
    const [userList, setUserList] = useState([])
    const [selectedPPEList, setSelectedPPEList] = useState([]);
    const [lineItemAutoCalculatedFields, setLineItemAutoCalculatedFields] = useState({
        elapsedTime: '',
        flowRate: '',
        fcc: '',
        twa: ''
    })
    const [weatherCity, setWeatherCity] = useState("");
    const [selectedOptions, setSelectedOptions] = useState({
        projectLocationId: null,
        analyzedBy: null,
        calibrationMethod: null,
        operation: null,
    })
    const [jobForm, setJobForm] = useState({
        id: 0,
        jobFormId: 0,
        projectNumber: "",
        client: "",
        name: "PCM Data Sheet",
        actualAssignedDate: null,
        submittedById: 0,
        jobId: 0,
        formLead: '',
        project: '',
        pcmDataSheet:{},
        pcmChainOfCustodyId: null,
        PCMChainOfCustodyJobFormId: null
    });
    const [options, setOptions] = useState({
        analyzedBy: ['AES', 'CA Labs', 'EMSL'],
        calibrationMethod: ['Dry Cal', 'Rotameter'],
        operation: ['Gross Removal', 'Secondary Removal']
    })
    const [lineItemOptions, setLineItemOptions] = useState({
        sampleType: ['Personal', 'Area', 'Blank'],
        ppe: ['1/2 Face Respirator', 'Full Face Respirator', 'Tyvek Disposable Coveralls', 'Gloves',
            'Safety Glasses', 'Goggles', 'Safety Toe Shoes', 'Ear Plugs', 'Hard Hat', 'Other']
    })
    const [lineItemSelectedOptions, setLineItemSelectedOptions] = useState({
        sampleType: null,
        ppe: null,
        user: null
    })
    const [showWeatherModal, setShowWeatherModal] = useState(false);

    useEffect(() => {
        setLoading(true);

        if (edit == 'false') {
            setSwitchMode(true)
            getReport(jobFormId)
        }
        else {
            fetchJobLocations().then(locations => {
                fetchPCMDataSheet(locations).then(res => {
                    pcmDataSheetService.getUsersFromProjectInfoSheet(res.jobId, res.projectId).then(userList => {
                        setUserList(userList);
                    });
                });
            });
        }

    }, []);

    const getReport = (id) => {
        if (id) {
            pcmDataSheetService.getReportPdf(id).then(res => {
                iframeRef.current.src = "data:application/pdf;base64," + res;
            }).catch(ex => {
            })
        }
    }

    const fetchJobLocations = () => jobFormService.getProposalProjectLocationsByJobFormId(jobFormId).then(res => {
        setLocationOptions(res);
        return res;
    });

    const hideWeatherModal = () => {
        setShowWeatherModal(false);
        setIsFetchingWeather(false);
    }

    const fetchPCMDataSheet = (projectLocations) => {
        return pcmDataSheetService.getPCMDataSheetById(jobFormId).then(res => {
            prefillSavedOptions(res.pcmDataSheet, projectLocations);
            setJobForm(res);
            setIsReadOnly(res.submittedById !== 0);
            delete res.pcmDataSheet.projectLocation;
            setPCMDataSheet(res.pcmDataSheet);

            return res;
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(() => setLoading(false));
    }

    const prefillSavedOptions = (model, projectLocations) => {
        let selectedProjectLocation = model.projectLocationId ? projectLocations.find(x => x.value == model.projectLocationId) : null
        setSelectedOptions({
            projectLocationId: selectedProjectLocation,
            analyzedBy: model.analyzedBy ? helper.setToOptionModel(model.analyzedBy, model.analyzedBy) : null,
            calibrationMethod: model.calibrationMethod ? helper.setToOptionModel(model.calibrationMethod, model.calibrationMethod) : null,
            operation: model.operation ? helper.setToOptionModel(model.operation, model.operation) : null
        })

        if (selectedProjectLocation) {
            setCityAndStateForWeather(selectedProjectLocation.label);
        }
    }

    const setCityAndStateForWeather = (address) => {
        let city = address.split(",");

        if (city.length > 2) {
            setWeatherCity(city[city.length - 2] + ", " + helper.getFullStateName(city[city.length - 1].trim()));
        }
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: pcmDataSheet,
        validationSchema: PCMDataSheetValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            saveForm(values).finally(() => {
                setLoading(false);
                setSubmitting(false);
            });
        }
    });

    const formik_lineItem = useFormik({
        enableReinitialize: true,
        initialValues: lineItemModel,
        validationSchema: PCMDataSheetLineItemValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            saveLineItem(values);
        }
    });

    const clearLineItemForm = () => {
        setShowExtra(false);
        formik_lineItem.resetForm();
        setLineItemSelectedOptions({ sampleType: null, ppe: null, user: null });
        setLineItemAutoCalculatedFields({
            elapsedTime: '',
            flowRate: '',
            fcc: '',
            twa: ''
        })
        setLineItemModel(lineItemInitialState);
    }

    const createPPEString = (option, val, i) => {
        var ppeString = '';
        if (i === option.length - 1) {
            ppeString += val.label;
        }
        else {
            ppeString += val.label + ', ';
        }
        return ppeString;
    }

    useEffect(() => {
        let finalObjToSet = {};
        calculateElapsedTimeT(finalObjToSet);
        calculateFlowRateT(finalObjToSet);
        calculateFccAndTwaT(finalObjToSet);

        setLineItemAutoCalculatedFields({ ...lineItemAutoCalculatedFields, ...finalObjToSet });
    }, [formik_lineItem.values])

    const calculateElapsedTimeT = (model) => {
        let { exposureTimeOff, exposureTimeOn, nonExposureTime } = formik_lineItem.values;
        if (exposureTimeOff && exposureTimeOn && nonExposureTime !== '') {
            let start = moment("2000/01/01 " + exposureTimeOn);
            let end = moment("2000/01/01 " + exposureTimeOff);

            model['elapsedTime'] = (moment.duration(end.diff(start)).asMinutes() - nonExposureTime);
        } else {
            model['elapsedTime'] = ''
        }
    }

    const calculateFlowRateT = (model) => {
        let { postCalibrationNumber, preCalibrationNumber, } = formik_lineItem.values;
        if (preCalibrationNumber && postCalibrationNumber) {
            model['flowRate'] = (preCalibrationNumber + postCalibrationNumber) / 2;
        }
        else {
            model['flowRate'] = '';
        }
    }

    const calculateFccAndTwaT = (model) => {
        let { sampleType, fields, fibers, preCalibrationNumber } = formik_lineItem.values;
        if (sampleType) {
            if (sampleType === "Blank") {
                model['fcc'] = '-';
                model['twa'] = '-';
                return;
            }
        }

        if (fields) {
            if (fields == 0) {
                model['fcc'] = '';
                return;
            }
        }

        // if (fibers) {
        //     if (fibers < 6) {
        //         model['fcc'] = '5.5';
        //         return;
        //     }
        // }

        // if (fibers && fields && model.elapsedTime && model.flowRate) {
        //     let sampleVolume = model.elapsedTime * model.flowRate;
        //     let fcc = (fibers / fields) * (49.04 / (sampleVolume));

        //     model['fcc'] = fcc;
        //     model['twa'] = sampleVolume == 0 ? " " : (fcc * model.elapsedTime / 480);
        // }
        if (fibers) {

            if (model.elapsedTime && model.flowRate) {
                let fcc = '';
                let sampleVolume = parseFloat(model.elapsedTime * model.flowRate).toFixed(3);
                if (fields) {
                    if (fibers < 6) {
                        fcc = 5.5 / fields * (49.04 / (sampleVolume));
                    }
                    else {
                        fcc = fibers / fields * (49.04 / (sampleVolume));
                    }
                }
                model['fcc'] = fcc ? parseFloat(fcc).toFixed(4) : '';
                model['twa'] = sampleVolume == 0 ? " " : parseFloat((fcc * model.elapsedTime / 480)).toFixed(4);
                return;
            }
        }
        else {
            model['fcc'] = 0.0000;
            model['twa'] = 0.0000
            return;
        }
    }

    const saveForm = (values) => {
        return pcmDataSheetService.save({ ...values, jobFormId: jobForm.id, collectedBy: jobForm.pcmDataSheet.collectedBy ? jobForm.pcmDataSheet.collectedBy : 
            jobForm.formLead }).then(res => {
            showAlert({ message: res.message, variant: 'success' })
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        })
    }

    const submitForm = () => {
        saveForm(formik.values).then(res => {
            jobFormService.submitForm(jobForm.id).then(res => {
                showAlert({ message: "Success! PCM Data Sheet has been submitted.", variant: 'success' });
                history.push("/services/manage-job/forms/" + jobForm.jobId);
            }).catch(ex => {
                showAlert({ message: ex.message, variant: 'error' })
            })
        }).catch(ex => { })
    }

    const discardCOC = () => {
        setProcessing();
        pcmChainOfCustodyService.discardCOC(jobForm.pcmChainOfCustodyId).then(res => {
            showAlert({ message: "Success! Chain Of Custody form has been discarded.", variant: 'success' });
            setJobForm({ ...jobForm, pcmChainOfCustodyId: null })
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(() => {
            hideConfirmModal();
        })
    }

    const generateCOC = () => {
        setProcessing();
        saveForm(formik.values).then(res => {
            pcmChainOfCustodyService.generatePCMChainOfCustody(pcmDataSheet.id).then(res => {
                showAlert({ message: "Success! PCM Chain Of Custody has been generated.", variant: 'success' });
                setJobForm({ ...jobForm, pcmChainOfCustodyId: res.id, pcmChainOfCustodyJobFormId: res.jobFormId })
            }).catch(ex => {
                showAlert({ message: ex.message, variant: 'error' });
            })
        }).catch(ex => { }).finally(() => {
            hideConfirmModal();
        })
    }

    const fetchCurrentWeatherCondition = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(fetchWeatherInfo, (error) => {
                let errorMessage = helper.getGeoLocationError(error);
                showAlert({ message: errorMessage, variant: 'warning' })
            });
        } else {
            showAlert({ message: "The request for geolocation has been denied. Please allow geolocation in your browser", variant: 'warning' })
        }
    }

    const fetchWeatherInfo = (position) => {
        if (!weatherCity)
            return;

        setIsFetchingWeather(true);
        weatherService.getCurrentWeatherCondition(encodeURIComponent(weatherCity.trim())).then(res => {
            formik.setFieldValue("windDirection", res[0].winddir16Point);
            formik.setFieldValue("maxWindSpeed", res[0].windspeedMiles + ' mph');
            formik.setFieldValue("humidity", res[0].humidity);
            formik.setFieldValue("temperature", res[0].temp_F + ' °F');
        }).catch(ex => {
            showAlert({ message: "The city you are trying to fetch the data from is not available. Please enter a valid or a different city name", variant: 'info' })
        }).finally(() => {
            setIsFetchingWeather(false);
        })
    }

    const saveLineItem = (values) => {
        values = { ...values, ...lineItemAutoCalculatedFields, dateTime: jobForm.actualAssignedDate, sampleVolume: (lineItemAutoCalculatedFields.elapsedTime * lineItemAutoCalculatedFields.flowRate).toFixed(3), pcmDataSheetId: pcmDataSheet.id }
        pcmDataSheetService.saveLineItem(values).then(res => {
            if (values.id > 0) {
                let temp = [...pcmDataSheet.pcmDataSheetLineItems];
                let indexOfEdited = temp.findIndex(x => x.id === values.id);
                temp[indexOfEdited] = values;
                setPCMDataSheet({ ...pcmDataSheet, pcmDataSheetLineItems: temp })
            } else {
                values.id = res.id;
                setPCMDataSheet({ ...pcmDataSheet, pcmDataSheetLineItems: [...pcmDataSheet.pcmDataSheetLineItems, values] })
            }

            clearLineItemForm();
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => setLoading(false))
    }


    const removeLineItem = (id) => {
        setLoading();
        setProcessing();
        pcmDataSheetService.deleteLineItem(id).then(res => {
            removeFromLineItemTable(id);
            showAlert({ message: res.message, variant: 'success' });
            setShowExtra(false);
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => {
            hideConfirmModal();
        })
    }

    const removeFromLineItemTable = (id) => {
        let temp = [...pcmDataSheet.pcmDataSheetLineItems];
        let indexOfEdited = temp.findIndex(x => x.id === id);

        if (indexOfEdited > -1) {
            temp.splice(indexOfEdited, 1);
            setPCMDataSheet({ ...pcmDataSheet, pcmDataSheetLineItems: temp });
        }
    }


    const lineItemInfoColumn = [
        {
            name: "Actions",
            selector: "id",
            sortable: true,
            omit: !auth.isAdmin && isReadOnly,
            minWidth: '10%',
            cell: row => <CustomBlock className="content-container--actions flex-start pl-0 mt-0">
                <Button
                    text="Edit"
                    className="info--bg ml-0"
                    size="xxs"
                    onClick={() => {
                        setShowExtra(true);
                        let final = {};
                        if (row.sampleType) {
                            final['sampleType'] = { label: row.sampleType, value: row.sampleType };

                            if (row.sampleType === "Personal" && row.sampleInformation) {
                                final['sampleInformation'] = { label: row.sampleInformation, value: row.sampleInformation };
                            }

                            if (row.ppe) {
                                final['ppe'] = (row.ppe.split(', ').map(x => {
                                    return { label: x, value: x };
                                }));
                            }

                            setLineItemSelectedOptions({ ...lineItemSelectedOptions, ...final });
                        }
                        setLineItemModel(row);
                    }}
                />
            </CustomBlock>

        },
        {
            name: "Sample No.",
            selector: "sampleNumber",
            sortable: true,
            minWidth: '10%'
        },
        {
            name: "Sample Information",
            selector: "sampleInformation",
            sortable: true,
            minWidth: '10%'
        },
        {
            name: "Worker ID",
            selector: "workerId",
            sortable: true,
            minWidth: '10%',
            cell: row => row.sampleType !== 'Personal' && <p>-</p>
        },
        {
            name: "PPE",
            selector: "ppe",
            sortable: true,
            minWidth: '50%'
        }
    ]

    const columns = [
        {
            name: "Actions",
            selector: "id",
            sortable: true,
            width: '160px',
            omit: !auth.isAdmin && isReadOnly,
            cell: row => <CustomBlock className="content-container--actions flex-start pl-0 mt-0">
                <Button
                    text="Edit"
                    className="info--bg ml-0"
                    size="xxs"
                    onClick={() => {
                        if (row.sampleType) {
                            setLineItemSelectedOptions({ ...lineItemSelectedOptions, sampleType: { label: row.sampleType, value: row.sampleType } })
                        }
                        setLineItemModel(row);
                    }}
                />

                <Button
                    text="Delete"
                    className="danger--bg ml-0"
                    size="xxs"
                    onClick={() => showConfirmModal({
                        title: "Delete Line Item",
                        text: "Are you sure you want to delete this line item?",
                        rightBtnText: "Confirm",
                        btnAction: () => removeLineItem(row.id)
                    })}
                />
            </CustomBlock>

        },
        {
            name: "Sample No.",
            selector: "sampleNumber",
            sortable: true,
        },
        {
            name: "Pump No.",
            selector: "pumpNumber",
            sortable: true,
        },
        {
            name: "Sample Type",
            selector: "sampleType",
            sortable: true,
        },
        {
            name: "Exposure Time On",
            selector: "exposureTimeOn",
            sortable: true,
        },
        {
            name: "Exposure Time Off",
            selector: "exposureTimeOff",
            sortable: true,
        },
        {
            name: "Non-Exposure Time",
            selector: "nonExposureTime",
            sortable: true,
        },
        {
            name: "Elapsed Time",
            selector: "elapsedTime",
            sortable: true,
        },
        {
            name: "Calibration Pre",
            selector: "preCalibrationNumber",
            sortable: true,
        },
        {
            name: "Calibration Post",
            selector: "postCalibrationNumber",
            sortable: true,
        },
        {
            name: "Flow Rate",
            selector: "flowRate",
            sortable: true,
        },
        {
            name: "Sample Volume",
            selector: "sampleVolume",
            sortable: true,
        },
        {
            name: "Fibers",
            selector: "fibers",
            sortable: true
        }, {
            name: "Fields",
            selector: "fields",
            sortable: true,
        },
        {
            name: "Analytical Result (f/cc)",
            selector: "fcc",
            sortable: true,
        },
        {
            name: "Analytical Result (8 hr TWA)",
            selector: "twa",
            sortable: true,
        }
    ];

    return (
        <>
            {
                switchMode ?
                    (<iframe ref={iframeRef} style={{ height: '100%', width: '100%' }} title="description"></iframe>)
                    :
                    (
                        <>
                            <Section removeContainer>
                                <ContentBlock>
                                    <CustomBlock className="content-container--card-style--with-shadow awork-mobile-form">
                                        <ContentHeader
                                            title={`Job #${jobForm.projectNumber} PCM-Air Data Sheet`}
                                            headerSize="md"
                                            primaryButtonText="Print Form"
                                            primaryButtonBackgroundColor="info--bg mr-0"
                                            primaryButtonOnClick={() => {
                                                setSwitchMode(true);
                                                getReport(jobForm ? jobForm.id : 0)
                                            }}
                                        />

                                        <CustomBlock>
                                            <Section removeContainer className="pb-10">
                                                <ContentBlock>
                                                    <ContentHeader
                                                        title="Header Information"
                                                        headerSize="sm"
                                                        className="fw-700 pb-10"
                                                    />
                                                </ContentBlock>
                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        label="Date"
                                                        value={moment(jobForm.actualAssignedDate).format("MM/DD/YYYY")}
                                                        disabled
                                                    />

                                                </ContentBlock>
                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        label="Collected By"
                                                        value={jobForm.pcmDataSheet.collectedBy ? jobForm.pcmDataSheet.collectedBy : jobForm.formLead}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        label="Job #/Client"
                                                        value={'#' + jobForm.projectNumber + ' / ' + jobForm.client}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <SelectBlock
                                                        isClearable
                                                        creatableSelect
                                                        label="Analyzed By"
                                                        inputState={formik.touched.analyzedBy && formik.errors.analyzedBy ? "error" : ""}
                                                        errorMessage={formik.errors.analyzedBy}
                                                        value={selectedOptions.analyzedBy}
                                                        options={options.analyzedBy.map(x => helper.setToOptionModel(x, x))}
                                                        onChange={selectedOption => {
                                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                                            setSelectedOptions({ ...selectedOptions, analyzedBy: selectedOption });
                                                            formik.setFieldValue("analyzedBy", selectedOption.value);
                                                        }}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <SelectBlock
                                                        label="Location"
                                                        inputState={formik.touched.projectLocationId && formik.errors.projectLocationId ? "error" : ""}
                                                        errorMessage={formik.errors.projectLocationId}
                                                        value={selectedOptions.projectLocationId}
                                                        options={locationOptions}
                                                        onChange={selectedOption => {
                                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                                            setSelectedOptions({ ...selectedOptions, projectLocationId: selectedOption });
                                                            formik.setFieldValue("projectLocationId", selectedOption.value);
                                                            if (selectedOption)
                                                                setCityAndStateForWeather(selectedOption.label ? selectedOption.label : "");
                                                        }}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        label="Analytical Method"
                                                        name="analyticalMethod"
                                                        id="analyticalMethod"
                                                        inputState={formik.touched.analyticalMethod && formik.errors.analyticalMethod ? "error" : ""}
                                                        errorMessage={formik.errors.analyticalMethod}
                                                        {...formik.getFieldProps("analyticalMethod")}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        label="Area"
                                                        name="area"
                                                        id="area"
                                                        inputState={formik.touched.area && formik.errors.area ? "error" : ""}
                                                        errorMessage={formik.errors.area}
                                                        {...formik.getFieldProps("area")}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <SelectBlock
                                                        label="Calibration Method"
                                                        inputState={formik.touched.calibrationMethod && formik.errors.calibrationMethod ? "error" : ""}
                                                        errorMessage={formik.errors.calibrationMethod}
                                                        value={selectedOptions.calibrationMethod}
                                                        options={options.calibrationMethod.map(x => helper.setToOptionModel(x, x))}
                                                        onChange={selectedOption => {
                                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                                            setSelectedOptions({ ...selectedOptions, calibrationMethod: selectedOption });
                                                            formik.setFieldValue("calibrationMethod", selectedOption.value);
                                                        }}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <SelectBlock
                                                        label="Operation"
                                                        inputState={formik.touched.operation && formik.errors.operation ? "error" : ""}
                                                        errorMessage={formik.errors.operation}
                                                        value={selectedOptions.operation}
                                                        options={options.operation.map(x => helper.setToOptionModel(x, x))}
                                                        onChange={selectedOption => {
                                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                                            setSelectedOptions({ ...selectedOptions, operation: selectedOption });
                                                            formik.setFieldValue("operation", selectedOption.value);
                                                        }}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        label="Calibration Number"
                                                        name="calibrationNumber"
                                                        id="calibrationNumber"
                                                        inputState={formik.touched.calibrationNumber && formik.errors.calibrationNumber ? "error" : ""}
                                                        errorMessage={formik.errors.calibrationNumber}
                                                        {...formik.getFieldProps("calibrationNumber")}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        label="Sample Media"
                                                        name="sampleMedia"
                                                        id="sampleMedia"
                                                        inputState={formik.touched.sampleMedia && formik.errors.sampleMedia ? "error" : ""}
                                                        errorMessage={formik.errors.sampleMedia}
                                                        {...formik.getFieldProps("sampleMedia")}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        label="Lot Number"
                                                        name="lotNumber"
                                                        id="lotNumber"
                                                        inputState={formik.touched.lotNumber && formik.errors.lotNumber ? "error" : ""}
                                                        errorMessage={formik.errors.lotNumber}
                                                        {...formik.getFieldProps("lotNumber")}
                                                    />
                                                </ContentBlock>
                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        label="Project"
                                                        value={jobForm.project}
                                                    />
                                                </ContentBlock>
                                            </Section>
                                            <Section removeContainer className="pt-10 pb-10 border-top">
                                                {(!auth.isAdmin ? !isReadOnly : true) && <>
                                                    <ContentBlock>
                                                        <ContentHeader
                                                            title="Line Item Entry"
                                                            headerSize="sm"
                                                            className="fw-700 pb-15"
                                                            primaryButtonText={lineItemModel.id > 0 ? "Update" : "Add" + " Line Item"}
                                                            primaryButtonOnClick={formik_lineItem.submitForm}
                                                            secondaryButtonText="Clear"
                                                            secondaryButtonOnClick={clearLineItemForm}
                                                        />
                                                    </ContentBlock>

                                                    <ContentBlock cols={2}>
                                                        <InputBlock
                                                            isRequired
                                                            label="Sample No."
                                                            name="sampleNumber"
                                                            id="sampleNumber"
                                                            inputState={formik_lineItem.touched.sampleNumber && formik_lineItem.errors.sampleNumber ? "error" : ""}
                                                            errorMessage={formik_lineItem.errors.sampleNumber}
                                                            {...formik_lineItem.getFieldProps("sampleNumber")}
                                                        />
                                                    </ContentBlock>
                                                    <ContentBlock cols={2}>
                                                        <InputBlock
                                                            isRequired
                                                            label="Pump No."
                                                            name="pumpNumber"
                                                            id="pumpNumber"
                                                            inputState={formik_lineItem.touched.pumpNumber && formik_lineItem.errors.pumpNumber ? "error" : ""}
                                                            errorMessage={formik_lineItem.errors.pumpNumber}
                                                            {...formik_lineItem.getFieldProps("pumpNumber")}
                                                        />
                                                    </ContentBlock>
                                                    <ContentBlock cols={4}>
                                                        <SelectBlock
                                                            isRequired
                                                            label="Sample Type"
                                                            inputState={formik_lineItem.touched.sampleType && formik_lineItem.errors.sampleType ? "error" : ""}
                                                            errorMessage={formik_lineItem.errors.sampleType}
                                                            value={lineItemSelectedOptions.sampleType}
                                                            options={lineItemOptions.sampleType.map(x => helper.setToOptionModel(x, x))}
                                                            onChange={selectedOption => {
                                                                selectedOption = selectedOption === null ? [] : selectedOption;
                                                                setLineItemSelectedOptions({ ...lineItemSelectedOptions, sampleType: selectedOption });
                                                                formik_lineItem.setFieldValue("sampleType", selectedOption.value);
                                                            }}
                                                        />
                                                    </ContentBlock>
                                                    <ContentBlock cols={2}>
                                                        <InputBlock
                                                            isRequired
                                                            type="date"
                                                            label="Exposure Time On"
                                                            placeholder="hh:mm"
                                                            options={{
                                                                enableTime: true,
                                                                dateFormat: "H:i",
                                                                time_24hr: true,
                                                                noCalendar: true
                                                            }}
                                                            value={formik_lineItem.getFieldProps("exposureTimeOn").value}
                                                            onChange={date => {
                                                                formik_lineItem.setFieldValue("exposureTimeOn", moment(date[0]).format("HH:mm"));
                                                            }}
                                                        />
                                                    </ContentBlock>
                                                    <ContentBlock cols={2}>
                                                        <InputBlock
                                                            isRequired
                                                            label="Exposure Time Off"
                                                            type="date"
                                                            placeholder="hh:mm"
                                                            options={{
                                                                enableTime: true,
                                                                dateFormat: "H:i",
                                                                time_24hr: true,
                                                                noCalendar: true
                                                            }}
                                                            value={formik_lineItem.getFieldProps("exposureTimeOff").value}
                                                            onChange={date => {
                                                                formik_lineItem.setFieldValue("exposureTimeOff", moment(date[0]).format("HH:mm"));
                                                            }}
                                                        />
                                                    </ContentBlock>
                                                    <ContentBlock cols={2}>
                                                        <InputBlock
                                                            isRequired
                                                            type="number"
                                                            label="Non-Exposure Time (Min)"
                                                            name="nonExposureTime"
                                                            id="nonExposureTime"
                                                            inputState={formik_lineItem.touched.nonExposureTime && formik_lineItem.errors.nonExposureTime ? "error" : ""}
                                                            errorMessage={formik_lineItem.errors.nonExposureTime}
                                                            {...formik_lineItem.getFieldProps("nonExposureTime")}
                                                        />
                                                    </ContentBlock>
                                                    <ContentBlock cols={2}>
                                                        <InputBlock
                                                            disabled
                                                            label="Elapsed Time (Min)"
                                                            value={lineItemAutoCalculatedFields.elapsedTime}
                                                        />
                                                    </ContentBlock>
                                                    <ContentBlock cols={2}>
                                                        <InputBlock
                                                            label="Calibration Pre (LPM)"
                                                            isRequired
                                                            type="number"
                                                            name="preCalibrationNumber"
                                                            id="preCalibrationNumber"
                                                            inputState={formik_lineItem.touched.preCalibrationNumber && formik_lineItem.errors.preCalibrationNumber ? "error" : ""}
                                                            errorMessage={formik_lineItem.errors.preCalibrationNumber}
                                                            {...formik_lineItem.getFieldProps("preCalibrationNumber")}
                                                        />
                                                    </ContentBlock>
                                                    <ContentBlock cols={2}>
                                                        <InputBlock
                                                            label="Calibration Post (LPM)"
                                                            isRequired
                                                            type="number"
                                                            name="postCalibrationNumber"
                                                            id="postCalibrationNumber"
                                                            inputState={formik_lineItem.touched.postCalibrationNumber && formik_lineItem.errors.postCalibrationNumber ? "error" : ""}
                                                            errorMessage={formik_lineItem.errors.postCalibrationNumber}
                                                            {...formik_lineItem.getFieldProps("postCalibrationNumber")}
                                                        />
                                                    </ContentBlock>
                                                    <ContentBlock cols={2}>
                                                        <InputBlock
                                                            label="Flow Rate (LPM)"
                                                            disabled
                                                            value={lineItemAutoCalculatedFields.flowRate}
                                                        />
                                                    </ContentBlock>
                                                    <ContentBlock cols={2}>
                                                        <InputBlock
                                                            label="Sample Volume (Litres)"
                                                            disabled
                                                            value={(lineItemAutoCalculatedFields.elapsedTime * lineItemAutoCalculatedFields.flowRate).toFixed(3)}
                                                        />
                                                    </ContentBlock>
                                                    <ContentBlock cols={2}>
                                                        <InputBlock
                                                            label="Fibers"
                                                            isRequired
                                                            type="number"
                                                            name="fibers"
                                                            id="fibers"
                                                            inputState={formik_lineItem.touched.fibers && formik_lineItem.errors.fibers ? "error" : ""}
                                                            errorMessage={formik_lineItem.errors.fibers}
                                                            {...formik_lineItem.getFieldProps("fibers")}
                                                        />
                                                    </ContentBlock>
                                                    <ContentBlock cols={2}>
                                                        <InputBlock
                                                            label="Fields"
                                                            isRequired
                                                            type="number"
                                                            name="fields"
                                                            id="fields"
                                                            inputState={formik_lineItem.touched.fields && formik_lineItem.errors.fields ? "error" : ""}
                                                            errorMessage={formik_lineItem.errors.fields}
                                                            {...formik_lineItem.getFieldProps("fields")}
                                                        />
                                                    </ContentBlock>
                                                    <ContentBlock cols={3}>
                                                        <InputBlock
                                                            label="Analytical Result (f/cc)"
                                                            disabled
                                                            value={lineItemAutoCalculatedFields.fcc}
                                                        />
                                                    </ContentBlock>
                                                    <ContentBlock cols={3}>
                                                        <InputBlock
                                                            label="Analytical Result (8 hr TWA)"
                                                            disabled
                                                            value={lineItemAutoCalculatedFields.twa}
                                                        />
                                                    </ContentBlock>
                                                </>}
                                                <ContentBlock>
                                                    <CustomBlock className="content-container--table-container">
                                                        <ContentHeader
                                                            title="Sample Line Items"
                                                            headerSize="md"
                                                            className="fw-700 dark-grey--clr pt-10"
                                                        />
                                                        <DataTable
                                                            columns={columns}
                                                            data={pcmDataSheet.pcmDataSheetLineItems}
                                                            pagination
                                                            subHeader
                                                            subHeaderAlign="left"
                                                        />
                                                        {/* <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Actions</TableCell>
                                                    <TableCell align="right">Sample No.</TableCell>
                                                    <TableCell align="right">Pump No.</TableCell>
                                                    <TableCell align="right">Sample Type</TableCell>
                                                    <TableCell align="right">Exposure Time On</TableCell>
                                                    <TableCell align="right">Exposure Time Off</TableCell>
                                                    <TableCell align="right">Non-Exposure Time</TableCell>
                                                    <TableCell align="right">Elapsed Time</TableCell>
                                                    <TableCell align="right">Calibration Pre</TableCell>
                                                    <TableCell align="right">Calibration Post</TableCell>
                                                    <TableCell align="right">Flow Rate</TableCell>
                                                    <TableCell align="right">Sample Volume</TableCell>
                                                    <TableCell align="right">Fibers</TableCell>
                                                    <TableCell align="right">Fields</TableCell>
                                                    <TableCell align="right">Analytical Result (f/cc)</TableCell>
                                                    <TableCell align="right">Analytical Result (8 hr TWA)</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {pcmDataSheet.pcmDataSheetLineItems.map((row) => (
                                                    <TableRow key={row.name}>
                                                        <TableCell component="th" scope="row">
                                                            <CustomBlock className="content-container--actions flex-start pl-0 mt-0">
                                                                <Button
                                                                    text="Edit"
                                                                    className="info--bg ml-0"
                                                                    size="xxs"
                                                                    onClick={() => {
                                                                        if (row.sampleType) {
                                                                            setLineItemSelectedOptions({ ...lineItemSelectedOptions, sampleType: { label: row.sampleType, value: row.sampleType } })
                                                                        }
                                                                        setLineItemModel(row);
                                                                    }}
                                                                />
                                                                <Button
                                                                    text="Delete"
                                                                    className="danger--bg ml-0"
                                                                    size="xxs"
                                                                    onClick={() => showConfirmModal({
                                                                        title: "Delete Line Item",
                                                                        text: "Are you sure you want to delete this line item?",
                                                                        rightBtnText: "Confirm",
                                                                        btnAction: () => removeLineItem(row.id)
                                                                    })}
                                                                />
                                                            </CustomBlock>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {row.sampleNumber}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {row.pumpNumber}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {row.sampleType}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {row.exposureTimeOn}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {row.exposureTimeOff}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {row.nonExposureTime}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {row.elapsedTime}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {row.preCalibrationNumber}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {row.postCalibrationNumber}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {row.flowRate}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {row.fibers}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {row.fields}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {row.fcc}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {row.twa}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table> */}
                                                    </CustomBlock>
                                                    {showExtra && <Section removeContainer className="pt-10 pb-10 border-top">
                                                        <ContentBlock>
                                                            <ContentHeader
                                                                title="Edit Line Item Entry"
                                                                headerSize="sm"
                                                                className="fw-700 pb-15"
                                                                primaryButtonText={"Update Line Item"}
                                                                primaryButtonOnClick={formik_lineItem.submitForm}
                                                                secondaryButtonText="Clear"
                                                                secondaryButtonOnClick={clearLineItemForm}
                                                            />
                                                        </ContentBlock>
                                                        {
                                                            formik_lineItem.values.sampleType === "Personal" ?
                                                                <ContentBlock cols={4}>
                                                                    <SelectBlock
                                                                        isRequired
                                                                        label="Select User"
                                                                        inputState={formik_lineItem.touched.sampleInformation && formik_lineItem.errors.sampleInformation ? "error" : ""}
                                                                        errorMessage={formik_lineItem.errors.sampleInformation}
                                                                        value={lineItemSelectedOptions.sampleInformation}
                                                                        options={userList.map(x => helper.setToOptionModel(x.name, x.name))}
                                                                        onChange={selectedOption => {
                                                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                                                            setLineItemSelectedOptions({ ...lineItemSelectedOptions, sampleInformation: selectedOption });
                                                                            formik_lineItem.setFieldValue("sampleInformation", selectedOption.value);
                                                                            formik_lineItem.setFieldValue("workerId", userList.find(x => x.name == selectedOption.value).aiNumber);
                                                                        }}
                                                                    />
                                                                </ContentBlock>
                                                                :
                                                                <>
                                                                    <ContentBlock cols={4}>
                                                                        <InputBlock
                                                                            isRequired
                                                                            label="Sample Information"
                                                                            name="sampleInformation"
                                                                            id="sampleInformation"
                                                                            inputState={formik_lineItem.touched.sampleInformation && formik_lineItem.errors.sampleNumber ? "error" : ""}
                                                                            errorMessage={formik_lineItem.errors.sampleInformation}
                                                                            {...formik_lineItem.getFieldProps("sampleInformation")}
                                                                        />
                                                                    </ContentBlock>

                                                                </>
                                                        }
                                                        {
                                                            formik_lineItem.values.sampleType === 'Personal'
                                                            &&
                                                            (
                                                                <ContentBlock cols={4}>
                                                                    <InputBlock
                                                                        isRequired
                                                                        label={"Worker ID"}
                                                                        disabled
                                                                        name="workerId"
                                                                        id="workerId"
                                                                        inputState={formik_lineItem.touched.workerId && formik_lineItem.errors.workerId ? "error" : ""}
                                                                        errorMessage={formik_lineItem.errors.workerId}
                                                                        {...formik_lineItem.getFieldProps("workerId")}
                                                                    />
                                                                </ContentBlock>
                                                            )
                                                        }
                                                        <ContentBlock cols={4}>
                                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                                PPE
                                                            </label>
                                                            <Select
                                                                isMulti
                                                                closeMenuOnSelect={false}
                                                                value={lineItemSelectedOptions.ppe}
                                                                options={lineItemOptions.ppe.map(x => helper.setToOptionModel(x, x))}
                                                                onChange={selectedOption => {
                                                                    selectedOption = selectedOption === null ? [] : selectedOption;
                                                                    var selectedPPEStrings = selectedOption.map(x => x.label).join(', ');
                                                                    setSelectedPPEList(selectedPPEStrings);
                                                                    setLineItemSelectedOptions({ ...lineItemSelectedOptions, ppe: selectedOption.value });
                                                                    formik_lineItem.setFieldValue("ppe", selectedPPEStrings);
                                                                }}
                                                            />
                                                        </ContentBlock>
                                                    </Section>
                                                    }

                                                    <CustomBlock className="content-container--table-container">
                                                        <ContentHeader
                                                            title="Line Items Information"
                                                            headerSize="md"
                                                            className="fw-700 dark-grey--clr pt-10"
                                                        />
                                                        <DataTable
                                                            columns={lineItemInfoColumn}
                                                            data={pcmDataSheet.pcmDataSheetLineItems}
                                                            pagination
                                                            subHeader
                                                            subHeaderAlign="left"
                                                        />
                                                    </CustomBlock>
                                                </ContentBlock>
                                            </Section>

                                            <Section removeContainer className="pt-10 pb-10 border-top">
                                                <ContentBlock>
                                                    <ContentHeader
                                                        title="Weather"
                                                        headerSize="sm"
                                                        className="fw-700 pb-15"
                                                        primaryButtonText={!isReadOnly && "Fetch Current Weather Info"}
                                                        primaryButtonLoading={isFetchingWeather}
                                                        primaryButtonOnClick={() => {
                                                            setShowWeatherModal(true);
                                                        }}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={2}>
                                                    <InputBlock
                                                        label="Wind Direction"
                                                        name="windDirection"
                                                        id="windDirection"
                                                        inputState={formik.touched.windDirection && formik.errors.windDirection ? "error" : ""}
                                                        errorMessage={formik.errors.windDirection}
                                                        {...formik.getFieldProps("windDirection")}
                                                    />
                                                </ContentBlock>
                                                <ContentBlock cols={2}>
                                                    <InputBlock
                                                        label="Max. Wind Speed"
                                                        name="maxWindSpeed"
                                                        id="maxWindSpeed"
                                                        inputState={formik.touched.maxWindSpeed && formik.errors.maxWindSpeed ? "error" : ""}
                                                        errorMessage={formik.errors.maxWindSpeed}
                                                        {...formik.getFieldProps("maxWindSpeed")}
                                                    />
                                                </ContentBlock>
                                                <ContentBlock cols={2}>
                                                    <InputBlock
                                                        label="Min. Wind Speed"
                                                        name="minWindSpeed"
                                                        id="minWindSpeed"
                                                        inputState={formik.touched.minWindSpeed && formik.errors.minWindSpeed ? "error" : ""}
                                                        errorMessage={formik.errors.minWindSpeed} minWindSpeed
                                                        {...formik.getFieldProps("minWindSpeed")}
                                                    />
                                                </ContentBlock>
                                                <ContentBlock cols={2}>
                                                    <InputBlock
                                                        label="Humidity"
                                                        name="humidity"
                                                        id="humidity"
                                                        inputState={formik.touched.humidity && formik.errors.humidity ? "error" : ""}
                                                        errorMessage={formik.errors.humidity}
                                                        {...formik.getFieldProps("humidity")}
                                                    />
                                                </ContentBlock>
                                                <ContentBlock cols={2}>
                                                    <InputBlock
                                                        label="Temperature (°F)"
                                                        name="temperature"
                                                        id="temperature"
                                                        inputState={formik.touched.temperature && formik.errors.temperature ? "error" : ""}
                                                        errorMessage={formik.errors.temperature}
                                                        {...formik.getFieldProps("temperature")}
                                                    />
                                                </ContentBlock>
                                            </Section>
                                            {!auth.isAdmin ?
                                                !isReadOnly &&
                                                <Section removeContainer className="pt-10">
                                                    <ContentBlock className="content-container--actions awork-save-bar">
                                                        <Button
                                                            text="Save Changes"
                                                            className="warning--bg"
                                                            onClick={formik.handleSubmit}
                                                        />
                                                        {
                                                            jobForm.pcmChainOfCustodyId ?
                                                                <>
                                                                    <Button
                                                                        text="Discard COC"
                                                                        onClick={() =>
                                                                            showConfirmModal({
                                                                                title: "Discard Chain Of Custody",
                                                                                text: "Are you sure you want to discard the current Chain Of Custody for this datasheet?",
                                                                                rightBtnText: "Confirm",
                                                                                btnAction: () => discardCOC()
                                                                            })
                                                                        }
                                                                        className="danger--bg"
                                                                    />

                                                                    <Button
                                                                        text="View COC"
                                                                        to={"/forms/pcm-coc/" + jobForm.pcmChainOfCustodyJobFormId + '/true'}
                                                                        className="info--bg"
                                                                    />
                                                                </>
                                                                :
                                                                <Button
                                                                    text="Generate COC"
                                                                    onClick={() =>
                                                                        showConfirmModal({
                                                                            title: "Generate Chain Of Custody",
                                                                            text: "Are you sure you want to generate a Chain Of Custody for this datasheet?",
                                                                            rightBtnText: "Confirm",
                                                                            btnAction: () => generateCOC()
                                                                        })
                                                                    }
                                                                    className="info--bg"
                                                                />
                                                        }
                                                        <Button
                                                            text="Submit Form"
                                                            onClick={submitForm}
                                                            className="success--bg"
                                                        />
                                                    </ContentBlock>
                                                </Section>
                                                :
                                                <Section removeContainer className="pt-10">
                                                    <ContentBlock className="content-container--actions awork-save-bar">
                                                        <Button
                                                            text="Save Changes"
                                                            className="warning--bg"
                                                            onClick={formik.handleSubmit}
                                                        />
                                                        {
                                                            jobForm.pcmChainOfCustodyId ?
                                                                <>
                                                                    <Button
                                                                        text="Discard COC"
                                                                        onClick={() =>
                                                                            showConfirmModal({
                                                                                title: "Discard Chain Of Custody",
                                                                                text: "Are you sure you want to discard the current Chain Of Custody for this datasheet?",
                                                                                rightBtnText: "Confirm",
                                                                                btnAction: () => discardCOC()
                                                                            })
                                                                        }
                                                                        className="danger--bg"
                                                                    />

                                                                    <Button
                                                                        text="View COC"
                                                                        to={"/forms/pcm-coc/" + jobForm.pcmChainOfCustodyJobFormId + '/true'}
                                                                        className="info--bg"
                                                                    />
                                                                </>
                                                                :
                                                                <Button
                                                                    text="Generate COC"
                                                                    onClick={() =>
                                                                        showConfirmModal({
                                                                            title: "Generate Chain Of Custody",
                                                                            text: "Are you sure you want to generate a Chain Of Custody for this datasheet?",
                                                                            rightBtnText: "Confirm",
                                                                            btnAction: () => generateCOC()
                                                                        })
                                                                    }
                                                                    className="info--bg"
                                                                />
                                                        }
                                                        {
                                                            !isReadOnly &&
                                                            <Button
                                                                text="Submit Form"
                                                                onClick={submitForm}
                                                                className="success--bg"
                                                            />
                                                        }
                                                    </ContentBlock>
                                                </Section>
                                            }
                                        </CustomBlock>
                                    </CustomBlock>
                                </ContentBlock>
                            </Section>

                            <Modal size='lg' show={showWeatherModal} onHide={hideWeatherModal}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Enter City for Weather Info</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="row">
                                        <div className="col-lg-6 col-xl-6">
                                            <InputBlock
                                                label="City"
                                                name="city"
                                                id="city"
                                                value={weatherCity}
                                                onChange={e => {
                                                    setWeatherCity(e.target.value)
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        text="Close"
                                        onClick={hideWeatherModal}
                                        className="danger--bg"
                                    />
                                    <Button
                                        text="Fetch"
                                        onClick={fetchCurrentWeatherCondition}
                                        className="primary--bg"
                                        loading={isFetchingWeather}
                                    />
                                </Modal.Footer>
                            </Modal>
                        </>
                    )
            }
        </>
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
})

export default connect(mapStateToProps, {
    ...alert.actions,
    ...confirmModal.actions
})(PCMDataSheetForm);